import React, { useState } from 'react';
import { ArrowLeftIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function SelfAssessmentPage() {
  const [currentStep, setCurrentStep] = useState(1);
  const totalSteps = 5;
  const goToNextStep = () => {
    if (currentStep < totalSteps) {
      setCurrentStep(currentStep + 1);
    }
  };
  const goToPreviousStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };
  return <div className="w-full min-h-screen bg-[#f8f8f8] py-12 px-6" data-id="element-2971">
      <div className="max-w-4xl mx-auto" data-id="element-2972">
        {/* Back button */}
        <div className="mb-8" data-id="element-2973">
          <Link to="/assessment" className="flex items-center text-gray-600 hover:text-[#631bb7] transition-colors" data-id="element-2974">
            <ArrowLeftIcon size={20} className="mr-2" data-id="element-2975" />
            <span className="font-medium" data-id="element-2976">Back</span>
          </Link>
        </div>
        {/* Progress indicator */}
        <div className="mb-8" data-id="element-2977">
          <div className="flex justify-between items-center mb-2" data-id="element-2978">
            <span className="text-sm font-bold text-[#631bb7]" data-id="element-2979">
              Step {currentStep} of {totalSteps}
            </span>
            <span className="text-sm font-semibold text-gray-500" data-id="element-2980">
              {Math.round(currentStep / totalSteps * 100)}% Complete
            </span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-2981">
            <div className="bg-[#631bb7] h-2 rounded-full transition-all duration-300" style={{
            width: `${currentStep / totalSteps * 100}%`
          }} data-id="element-2982"></div>
          </div>
        </div>
        {/* Assessment Content */}
        <div className="bg-white rounded-2xl p-8 border-2 border-gray-200" data-id="element-2983">
          {currentStep === 1 && <div data-id="element-2984">
              <h1 className="text-3xl md:text-4xl font-bold text-[#111111] mb-6" data-id="element-2985">
                Let's start with the basics
              </h1>
              <p className="text-gray-600 mb-8 leading-relaxed" data-id="element-2986">
                We'll ask you a few questions to understand your current setup.
              </p>
              <div className="space-y-6 mb-8" data-id="element-2987">
                <div className="border-2 border-gray-200 rounded-xl p-6" data-id="element-2988">
                  <h3 className="text-xl font-bold text-[#111111] mb-4" data-id="element-2989">
                    Do you use a password manager?
                  </h3>
                  <div className="space-y-3" data-id="element-2990">
                    <label className="flex items-center p-4 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-[#631bb7] transition-colors" data-id="element-2991">
                      <input type="radio" name="password_manager" className="mr-3 w-4 h-4 accent-[#631bb7]" data-id="element-2992" />
                      <span className="font-medium" data-id="element-2993">
                        Yes, for all my accounts
                      </span>
                    </label>
                    <label className="flex items-center p-4 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-[#631bb7] transition-colors" data-id="element-2994">
                      <input type="radio" name="password_manager" className="mr-3 w-4 h-4 accent-[#631bb7]" data-id="element-2995" />
                      <span className="font-medium" data-id="element-2996">
                        Yes, for some accounts
                      </span>
                    </label>
                    <label className="flex items-center p-4 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-[#631bb7] transition-colors" data-id="element-2997">
                      <input type="radio" name="password_manager" className="mr-3 w-4 h-4 accent-[#631bb7]" data-id="element-2998" />
                      <span className="font-medium" data-id="element-2999">
                        No, I remember them or write them down
                      </span>
                    </label>
                    <label className="flex items-center p-4 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-[#631bb7] transition-colors" data-id="element-3000">
                      <input type="radio" name="password_manager" className="mr-3 w-4 h-4 accent-[#631bb7]" data-id="element-3001" />
                      <span className="font-medium" data-id="element-3002">
                        I'm not sure what that is
                      </span>
                    </label>
                  </div>
                </div>
              </div>
              <div className="flex justify-end" data-id="element-3003">
                <button onClick={goToNextStep} className="bg-[#631bb7] text-white px-8 py-3 rounded-lg font-bold hover:bg-[#521099] transition-all shadow-md" data-id="element-3004">
                  Continue
                </button>
              </div>
            </div>}
          {currentStep === 2 && <div data-id="element-3005">
              <h1 className="text-3xl md:text-4xl font-bold text-[#111111] mb-6" data-id="element-3006">
                Two-factor authentication
              </h1>
              <p className="text-gray-600 mb-8 leading-relaxed" data-id="element-3007">
                This adds an extra layer of security to your accounts.
              </p>
              <div className="space-y-6 mb-8" data-id="element-3008">
                <div className="border-2 border-gray-200 rounded-xl p-6" data-id="element-3009">
                  <h3 className="text-xl font-bold text-[#111111] mb-4" data-id="element-3010">
                    Do you use two-factor authentication (2FA)?
                  </h3>
                  <div className="space-y-3" data-id="element-3011">
                    <label className="flex items-center p-4 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-[#631bb7] transition-colors" data-id="element-3012">
                      <input type="radio" name="two_factor" className="mr-3 w-4 h-4 accent-[#631bb7]" data-id="element-3013" />
                      <span className="font-medium" data-id="element-3014">
                        Yes, for all important accounts
                      </span>
                    </label>
                    <label className="flex items-center p-4 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-[#631bb7] transition-colors" data-id="element-3015">
                      <input type="radio" name="two_factor" className="mr-3 w-4 h-4 accent-[#631bb7]" data-id="element-3016" />
                      <span className="font-medium" data-id="element-3017">
                        Yes, for some accounts
                      </span>
                    </label>
                    <label className="flex items-center p-4 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-[#631bb7] transition-colors" data-id="element-3018">
                      <input type="radio" name="two_factor" className="mr-3 w-4 h-4 accent-[#631bb7]" data-id="element-3019" />
                      <span className="font-medium" data-id="element-3020">No, I don't use it</span>
                    </label>
                    <label className="flex items-center p-4 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-[#631bb7] transition-colors" data-id="element-3021">
                      <input type="radio" name="two_factor" className="mr-3 w-4 h-4 accent-[#631bb7]" data-id="element-3022" />
                      <span className="font-medium" data-id="element-3023">
                        I'm not sure what that is
                      </span>
                    </label>
                  </div>
                </div>
              </div>
              <div className="flex justify-between" data-id="element-3024">
                <button onClick={goToPreviousStep} className="border-2 border-gray-300 text-[#111111] px-8 py-3 rounded-lg font-bold hover:border-[#631bb7] hover:text-[#631bb7] transition-colors" data-id="element-3025">
                  Back
                </button>
                <button onClick={goToNextStep} className="bg-[#631bb7] text-white px-8 py-3 rounded-lg font-bold hover:bg-[#521099] transition-all shadow-md" data-id="element-3026">
                  Continue
                </button>
              </div>
            </div>}
          {currentStep > 2 && <div data-id="element-3027">
              <h1 className="text-3xl md:text-4xl font-bold text-[#111111] mb-6" data-id="element-3028">
                Assessment Step {currentStep}
              </h1>
              <p className="text-gray-600 mb-8 leading-relaxed" data-id="element-3029">
                This is a placeholder for step {currentStep} of the assessment.
              </p>
              <div className="flex justify-between" data-id="element-3030">
                <button onClick={goToPreviousStep} className="border-2 border-gray-300 text-[#111111] px-8 py-3 rounded-lg font-bold hover:border-[#631bb7] hover:text-[#631bb7] transition-colors" data-id="element-3031">
                  Back
                </button>
                <button onClick={goToNextStep} className="bg-[#631bb7] text-white px-8 py-3 rounded-lg font-bold hover:bg-[#521099] transition-all shadow-md" data-id="element-3032">
                  Continue
                </button>
              </div>
            </div>}
        </div>
      </div>
    </div>;
}